var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"ml-3",class:_vm.component.id},[_c(_vm.input.tagName,_vm._b({tag:"component",model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'component',_vm.input.bindings,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }